import React, { useEffect, useMemo, useState } from "react";
import { Stack, Tab, Tabs, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import LiveTab from "./LiveTab";
import HealthTab from "./HealthTab";
import ErrorsTab from "./ErrorsTab";
import UsageTab from "./UsageTab";
import LicensesTab from "./LicensesTab";

// El Pulso: como y cuanto usan Haulers los clientes, en vivo. Solo el equipo de Kargotools
// (superadmin con correo @kargotools.com, el mismo criterio que el backend).
const PulseIndex = () => {
    const navigate = useNavigate();
    const { authUser } = useJumboAuth();
    const [tab, setTab] = useState("live");

    const allowed = useMemo(() => {
        const superadmin = (authUser?.profiles || []).some((p) => p.name === "superadmin");
        return superadmin && /@kargotools\.com$/i.test(authUser?.email || "");
    }, [authUser]);

    useEffect(() => {
        if (authUser && !allowed) navigate("/trips");
    }, [authUser, allowed, navigate]);

    if (!allowed) return null;

    return (
        <Stack spacing={2}>
            <div>
                <Typography variant="h2" sx={{ mb: 0.5 }}>Pulso</Typography>
                <Typography variant="body2" color="text.secondary">
                    Cómo y cuánto usan Haulers los clientes, en la web y en la app: lo que programan, optimizan y entregan, y lo que les falla.
                </Typography>
            </div>
            <Tabs value={tab} onChange={(e, v) => setTab(v)} variant="scrollable" allowScrollButtonsMobile>
                <Tab value="live" label="En vivo" />
                <Tab value="health" label="Clientes" />
                <Tab value="errors" label="Errores" />
                <Tab value="usage" label="Uso" />
                <Tab value="licenses" label="Licencias" />
            </Tabs>
            {tab === "live" && <LiveTab />}
            {tab === "health" && <HealthTab />}
            {tab === "errors" && <ErrorsTab />}
            {tab === "usage" && <UsageTab />}
            {tab === "licenses" && <LicensesTab />}
        </Stack>
    );
};

export default PulseIndex;
